import type { CustomLoadingOverlayProps } from "ag-grid-react";

import { Spinner, makeStyles, mergeClasses } from "@fluentui/react-components";

const useStyles = makeStyles({
    loading: {
        height: "50",
        width: "120",
        padding: "5px",
        margin: "0 auto",
    }
});

export default function GridLoadingOverlay(props: CustomLoadingOverlayProps & { loadingMessage: string }) {
    const styles = useStyles();

    return (
        <div className="ag-overlay-loading-center" role="presentation">
            <div
                role="presentation"
                className={mergeClasses(styles.loading, "custom-loading-overlay")}
            >
                <Spinner aria-label="loading..."/>
            </div>
            <div aria-live="polite" aria-atomic="true">
                {props.loadingMessage}
            </div>
        </div>
    );
}